import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
import { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Spinner } from 'react-bootstrap-v5';
import ReactDOM from 'react-dom';
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-toastify';
import CourierLabel from '../../../../Function/CourierLabel';
import { vendorService } from "../../../../Services";
import CourierPartnerService from "../../../../Services/CourierPartnerService";

const CourierPartner = ({ jobData, itemList, pickupList, job_token, receiver_details, disabled }) => {
  const [state, setState] = useState([])
  const [cpList, setCpList] = useState([])
  const [selectedCP, setSelectedCP] = useState('')
  const [loader, setLoader] = useState(false)
  const [errors, setErrors] = useState(null)
  const [confirmModal, setConfirmModal] = useState({ open: false, data: null })
  const [courierLoadingIndex, setCourierLoadingIndex] = useState(null);
  const [manualAwb, setManualAwb] = useState('');
  const [isOfflinePartner, setIsOfflinePartner] = useState(false);
  const [showErr, serShowErr] = useState(false);

  const handleClose = () => {
    setErrors([])
    setConfirmModal({ open: false, data: null })
  }

  useEffect(() => {
    setLoader(true);
    const wrappedItem = itemList.reduce((acc, cur) => {
      const pickup = pickupList.find((item) => item.what_to_pickup.includes(cur.actual.item_description))
      if (acc[cur.actual.item_description]) {
        acc[cur.actual.item_description].total_weight_KG += Number(cur.actual.total_weight_KG)
        acc[cur.actual.item_description].total_volume_CBM += Number(cur.actual.total_volume_CBM)
      } else {
        acc[cur.actual.item_description] = {
          item_description: cur.actual.item_description,
          no_of_pkgs: cur.actual.no_of_pkgs,
          total_weight_KG: Number(cur.actual.total_weight_KG),
          total_volume_CBM: Number(cur.actual.total_volume_CBM),
          goods_value: cur.actual?.goods_value,
          courier_partner: pickup?.courier_partner,
          cp_awb_number: pickup?.cp_awb_number,
          pickup: pickup
        }
      }
      return acc
    }, {})
    setState(Object.values(wrappedItem).filter((item) => item.pickup?._id))
    getCourierPartnerList()
  }, [])

  const getCourierPartnerList = async () => {
    await vendorService.getVendor({ type: "Courier" })
      .then((res) => {
        setLoader(false);
        if (res.status) {
          const formateData = res.data.map((item) => ({
            ...item,
            label: item.business_name,
            value: item._id,
          }))
          setCpList(formateData);
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err.message);
        console.log(err, "err");
      });
  };

  const selectCourierPartner = (e, item) => {
    const value = e.target.value;
    const vendor = cpList && cpList.find((v) => v.business_name === value);

    serShowErr(false);
    setManualAwb('');
    setIsOfflinePartner(false);

    if (!value) return;

    const selectedData = { ...item, courier_partner: value };

    if (value === "WORLD2DOOR") {
      setIsOfflinePartner(false);
      setConfirmModal({ open: true, data: selectedData });
      return;
    }

    if (vendor) {
      const isOffline = vendor.service_type === "OFFLINE";
      setIsOfflinePartner(isOffline);
      setConfirmModal({ open: true, data: selectedData });
      return;
    } else {
      toast.error("Vendor not found");
    }
  };

  const assignCourierPartner = async () => {
    if (isOfflinePartner && !manualAwb.trim()) {
      serShowErr(true)
      return;
    }
    setLoader(true);
    await CourierPartnerService.assignCourierPartner({
      job_token: job_token,
      pickup: confirmModal.data.pickup,
      cp_id: confirmModal.data.courier_partner,
      consignee: receiver_details,
      awb_number: isOfflinePartner ? manualAwb.trim() : undefined,
    })
      .then((res) => {
        setLoader(false);
        if (res.status) {
          const findItemIndex = state.findIndex((item) => item.item_description === confirmModal.data.item_description)
          const stateCopy = JSON.parse(JSON.stringify(state))
          stateCopy[findItemIndex].courier_partner = confirmModal.data.courier_partner
          stateCopy[findItemIndex].cp_awb_number = res.data?.awb_number
          setState(stateCopy)
          toast.success(res.message)
          handleClose()
        } else {
          if (res.message === "Validation Error") {
            setErrors(res.errors)
          }
          toast.error(res.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err.message);
        console.log(err, "err");
      });
  }

  function openPdf(awbFile) {
    const pdfData = `data:application/pdf;base64,${awbFile}`;
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`
      <html>
        <head>
          <style>
            html, body {
              margin: 0;
            }
            iframe {
              border: none;
              width: 100%;
              height: 100%;
            }
          </style>
        </head>
        <body>
          <iframe src="${pdfData}"></iframe>
        </body>
      </html>
    `);
    }
  }

  const generatePdf = async (item , vendor) => {
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.top = "0";
    document.body.appendChild(container);

    ReactDOM.render(<CourierLabel data={item} vendor={vendor} />, container);

    await new Promise((resolve) => setTimeout(resolve, 500));

    const canvas = await html2canvas(container, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true,
      logging: true,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = 210;
    const imgHeight = (canvas.height * pageWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
  };

  const getCourierLabel = async (item, index) => {
    setCourierLoadingIndex(index);
    const vendor = cpList && cpList.find((v) => v.business_name === item.courier_partner);
    if (item.courier_partner === "WORLD2DOOR" || vendor?.service_type === "OFFLINE") {
      await generatePdf(jobData ,vendor);
      setCourierLoadingIndex(null);
    } else {
      const param = { cp_awb_number: item.cp_awb_number };
      await CourierPartnerService.getCourierPartnerLabel(param)
        .then((res) => {
          setCourierLoadingIndex(null);
          if (res.status) {
            openPdf(res.data.data.invoice);
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => {
          setCourierLoadingIndex(null);
          console.log(error);
        });
    }
  };

  return (
    <Card>
      <div className="card-header bg-light">
        <h4>Courier Partners</h4>
      </div>
      <Card.Body>
        <div className="table-responsive">
          <table className="table table-centered mb-0">
            <thead className="table-light">
              <tr>
                <th>Item Description</th>
                <th>No. Pkgs</th>
                <th>Total Weight</th>
                <th>Total Volume</th>
                <th>Goods Value</th>
                <th style={{ width: "25%" }}>Courier Partner</th>
                <th>AWB Number</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <tr>
                  <td colSpan={8} className="text-center">
                    <Spinner animation="grow" size="sm" />{" "}
                  </td>
                </tr>
              ) : (
                (state &&
                  Array.isArray(state) &&
                  state.length > 0 &&
                  state.map((item, i) => {
                    if (!item.pickup._id) return false
                    let rowSpan = false
                    if (i === 0) {
                      rowSpan = item?.pickup.what_to_pickup.length
                    } else {
                      rowSpan = item.pickup._id === state[i - 1]?.pickup._id ? false : item?.pickup?.what_to_pickup.length
                    }
                    return (
                      <tr key={i}>
                        <td>{item?.item_description || "-"}</td>
                        <td>{item?.no_of_pkgs ?? "-"}</td>
                        <td>{item?.total_weight_KG ?? "-"}</td>
                        <td>{item?.total_volume_CBM ?? "-"}</td>
                        <td>{item?.goods_value ?? "-"}</td>
                        {rowSpan &&
                          <td rowSpan={rowSpan}>
                            <Form.Select
                              aria-label="CP list"
                              name="courier_partner"
                              onChange={(e) => selectCourierPartner(e, item)}
                              disabled={item.courier_partner || disabled}
                              value={item.courier_partner}
                            >
                              <option className="text-secondary" value="" >Select Courier Partner</option>
                              <option value={"WORLD2DOOR"} >World2Door</option>
                              {cpList.length &&
                                cpList.map((itm, idx) => {
                                  return (
                                    <option key={idx} value={itm.business_name}>
                                      {itm.business_name}
                                    </option>
                                  );
                                })}
                            </Form.Select>
                          </td>
                        }
                        {rowSpan &&
                          <td rowSpan={rowSpan}>{item?.cp_awb_number ?? "-"}</td>
                        }
                        {rowSpan &&
                          <td rowSpan={rowSpan}>
                            <Button
                              onClick={() => {
                                getCourierLabel(item, i);
                              }}
                              className="m-1"
                              disabled={
                                item?.courier_partner
                                  ? false
                                  : true
                              }
                            >
                              {(courierLoadingIndex === i && (
                                <Spinner
                                  as="span"
                                  animation="grow"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              )) || <FaDownload />}
                            </Button>
                          </td>
                        }
                      </tr>
                    )
                  })) || (
                  <tr>
                    <td colSpan={8} className="text-center">
                      Data Not Available
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        {confirmModal.open && (
          <Modal
            size="md"
            show={confirmModal.open}
            onHide={() => handleClose()}
            aria-labelledby="example-modal-sizes-title-md"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-md">
                Confirm Selection
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>Are you sure want to select courier partner?</div>
              <br />
              <table>
                <tbody style={{ verticalAlign: "baseline" }}>
                  {confirmModal.data.pickup.what_to_pickup.map((item, i) => (
                    <tr key={i}>
                      <td><b>{i === 0 ? "Items" : ""}</b></td>
                      <td className='px-2'>{i === 0 ? "-" : ""}</td>
                      <td className='pb-2'>{item}</td>
                    </tr>
                  ))}
                  <tr className='border-top'>
                    <td style={{ whiteSpace: "nowrap" }}><b>Courier Partner</b></td>
                    <td className='px-2'>-</td>
                    <td>{confirmModal.data.courier_partner}</td>
                  </tr>

                  {isOfflinePartner && (
                    <>
                      <tr className="border-top">
                        <td><b>AWB Number</b></td>
                        <td className="px-2">-</td>
                        <td>
                          <Form.Control
                            type="text"
                            placeholder="Enter AWB Number"
                            value={manualAwb}
                            onChange={(e) => setManualAwb(e.target.value)}
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ whiteSpace: "nowrap" }}><b></b></td>
                        <td className='px-2'></td>
                        <td>
                          {showErr && !manualAwb.trim() && (
                            <td className="text-danger">Please enter AWB number</td>
                          )}
                        </td>
                      </tr>

                    </>
                  )}
                </tbody>
              </table>

              {errors && Array.isArray(errors) && errors.length > 0 &&
                <div className='mt-3 border p-3 pb-0' style={{ width: "fit-content" }}>
                  <h6 >Please fill the following fields to continue</h6>
                  <ul className='text-danger' >
                    {errors.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </div>
              }
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" className='px-3' onClick={() => handleClose()}>
                Cancel
              </Button>
              <Button variant="primary" className='px-4'
                onClick={() => !loader && assignCourierPartner()}>
                {loader ? <Spinner animation="grow" size="sm" /> : "Confirm"}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Card.Body>
    </Card>
  );
}

export default CourierPartner
